import { getRemoteHost, doAjax } from "../../api/api_request.js";

/**
 * @typedef {Object.<ActuatorId, ConfigCheckerStepResult[]>} ConfigCheckerResult
 */

/**
 * @typedef {string} ActuatorId
 */

/**
 * @typedef {Object} ConfigCheckerStepResult
 * @property {string[]} logs
 * @property {Object} parameters
 * @property {Object.<string, ValidationResult>} validatables
 */

/**
 * @typedef {Object} ValidationResult
 * @property {boolean} isValid
 * @property {string} name
 */

/**
 * @param {Object} body
 * @param {(configCheckerResult: ConfigCheckerResult) => void} pOnSuccess
 * @param {(error: string) => void} pOnError
 */
function insertResultForActuator(body, pOnSuccess, pOnError) {
  doAjax({
    url: `${getRemoteHost()}/v1/configChecker/insertResult`,
    type: "POST",
    dataType: "json",
    contentType: 'application/json',
    data: JSON.stringify(body),
    success: (configCheckerResult) => {
      console.log(`Config checker result saved!`, configCheckerResult);
      pOnSuccess(configCheckerResult);
    },
    error: (_xhr, status, error) => {
      console.error(`Config checker result failed to save... Status: ${status}, error: ${error}`);
      pOnError(error);
    }
  });
}

function getResultStatus(pControllerId, pAxisUuid, pOnComplete, pOnError) {
  doAjax({
    url: `${getRemoteHost()}/v1/configChecker/getResultStatus?controllerId=${pControllerId}&axisUuid=${pAxisUuid}`,
    type: "GET",
    dataType: "json",
    success: function(_pData) { pOnComplete(_pData); },
    error: function (xhr, status, error) {
      pOnError && pOnError(error);
    }
  });
}

function getAllResults(pControllerId, pOnComplete, pOnError) {
  doAjax({
    url: `${getRemoteHost()}/v1/configChecker/getAllResults?controllerId=${pControllerId}`,
    type: "GET",
    dataType: "json",
    success: function(_pData) { pOnComplete(_pData); },
    error: function (xhr, status, error) {
      console.error('failed to get all results');
      pOnError && pOnError(error);
    }
  });
}


export default {
  insertResultForActuator,
  getResultStatus,
  getAllResults,
};
